// Menu do jogo organizado por categorias, com nomes (reclamação geral dos jogadores, 25/10: "não consigo me localizar").
// Usado no painel da direita do computador, na busca de funções (Ctrl+K) e nas abas de baixo do celular.
// Cada entrada abre um botão de controle (controls.ts) ou uma ação do jogo (Auto Helper, Venda rápida, Opções...).
import { CONTROLS, type ControlButton } from './controls';

const IMG = '/assets/interface/images';

export interface MenuItem {
  key: string;
  label: string;
  /** o que abrir: botão de controle ou ação por nome (openContent do Game) */
  open: ControlButton | string;
  icon?: string;
  desc: string;
  /** outras palavras que a busca reconhece */
  alias?: string;
}
export interface MenuCat { id: 'caca' | 'conteudos' | 'personagem' | 'itens' | 'social'; label: string; items: MenuItem[] }

const ctl = (id: string, label?: string, alias?: string): MenuItem => {
  const b = CONTROLS.find((c) => c.id === id);
  if (!b) throw new Error('menu: controle desconhecido ' + id);
  return { key: id, label: label ?? b.label, open: b, icon: b.up, desc: b.about === '__widget__' ? '' : b.about, ...(alias ? { alias } : {}) };
};
const act = (key: string, label: string, desc: string, icon?: string, alias?: string): MenuItem => ({ key, label, open: key, desc, ...(icon ? { icon } : {}), ...(alias ? { alias } : {}) });

export const MENU: MenuCat[] = [
  { id: 'caca', label: 'Caça', items: [
    ctl('hunts', 'Hunts', 'caves cavernas mapa caçar teleporte'),
    act('gambits', 'Auto Helper', 'Magias, curas, poções e movimentação da caça automática.', `${IMG}/icon-magicalarchive-combatstats.png`, 'helper cura pocao potion magia auto hunt'),
    ctl('analytics', 'Hunt Analyser', 'analyser analise xp hora loot tracker bestiario'),
    ctl('battle', undefined, 'lista batalha monstros'),
    ctl('prey', undefined, 'bonus criatura'),
    ctl('tasks', undefined, 'tarefas bounty weekly semanais talisman'),
    ctl('bosses', undefined, 'boss chefe auto boss'),
    ctl('bosstiary', undefined, 'bosses progresso'),
    ctl('bossslots', undefined, 'boss slot loot'),
    ctl('wild', undefined, 'descampado'),
    ctl('quests', undefined, 'annihilator demon helmet inquisition missao'),
  ] },
  { id: 'conteudos', label: 'Conteúdos', items: [
    ctl('fendas', undefined, 'dungeon dungeons rift'),
    ctl('torre', undefined, 'tower andares'),
    ctl('labirinto', undefined, 'baus caos'),
    ctl('coliseu', undefined, 'waves ondas ranking'),
    ctl('expedicoes', undefined, 'ecos'),
    ctl('ameaca', undefined, 'world boss servidor'),
    ctl('heroi', undefined, 'pvp batalha arena'),
    ctl('treino', undefined, 'training monk skill offline treinar'),
    ctl('eventos', undefined, 'calendario double xp loot'),
  ] },
  { id: 'personagem', label: 'Personagem', items: [
    ctl('skills', undefined, 'habilidades sword axe club distance magic level'),
    ctl('spells', 'Magias', 'lista magias runas spells'),
    ctl('wheel', undefined, 'roda destino gemas avatar'),
    ctl('proficiency', undefined, 'proficiencia arma'),
    ctl('reset', undefined, 'resets'),
    ctl('outfits', undefined, 'roupa aparencia addon montaria mount'),
    ctl('cards', undefined, 'cartas'),
    act('achievements', 'Conquistas', 'Achievements: conquistas e pontos.', `${IMG}/icon-achievement.png`, 'achievements'),
    ctl('cyclopedia', undefined, 'bestiario charms enciclopedia'),
    act('bless', 'Bênçãos', 'Blessings: protegem sua experiência e itens ao morrer.', `${IMG}/blessings/button-blessings-gold-idle.png`, 'blessings bless morte'),
  ] },
  { id: 'itens', label: 'Itens', items: [
    ctl('depot', undefined, 'deposito guardar'),
    act('storebox', 'Store Box', 'Itens da loja, recompensas e eventos.', `${IMG}/icon-inbox.png`, 'caixa recompensa'),
    act('sell', 'Venda rápida', 'Vende o loot comum que você carrega.', `${IMG}/icon-goldcoin.png`, 'vender loot npc'),
    ctl('mercado', undefined, 'market comprar vender jogadores'),
    ctl('forge', 'Forge', 'forja exaltation fusao tier'),
    ctl('refine', undefined, 'refinar +30 pedra protecao'),
    ctl('imbuir', undefined, 'imbuement imbuir'),
    ctl('casas', undefined, 'house casa leilao'),
  ] },
  { id: 'social', label: 'Social', items: [
    ctl('party', undefined, 'grupo'),
    ctl('guild', undefined, 'guilda cerco castelo'),
    ctl('vip', undefined, 'amigos'),
    ctl('social', undefined, 'mensagens'),
    ctl('highscores', undefined, 'ranking rank'),
    ctl('rewardwall', undefined, 'daily diaria login'),
    ctl('roleta', undefined, 'premios sorteio'),
    act('store', 'Noxara Store', 'Loja de Noxara Coins.', `${IMG}/button-store-small-up.png`, 'loja coins comprar'),
    ctl('discord', 'Discord', 'suporte wiki changelog'),
    act('options', 'Opções', 'Som, gráficos e preferências do jogo.', `${IMG}/icon-options.png`, 'options configuracoes'),
  ] },
];

export const ALL_ITEMS: MenuItem[] = MENU.flatMap((c) => c.items);

/** sem acento e minúsculo, para a busca */
export const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** busca: o nome começando com o texto vem primeiro, depois nome contendo, depois descrição/apelidos */
export function searchMenu(q: string): MenuItem[] {
  const t = norm(q.trim());
  if (!t) return [];
  const words = t.split(/\s+/);
  const scored: Array<[number, MenuItem]> = [];
  for (const it of ALL_ITEMS) {
    const name = norm(it.label), rest = norm(`${it.desc} ${it.alias ?? ''} ${it.key}`);
    if (!words.every((w) => name.includes(w) || rest.includes(w))) continue;
    scored.push([name.startsWith(t) ? 0 : name.includes(t) ? 1 : 2, it]);
  }
  return scored.sort((a, b) => a[0] - b[0]).map(([, it]) => it);
}

const FAV_KEY = 'nx-menu-favs';
const FAV_DEFAULT = ['hunts', 'gambits', 'prey', 'tasks', 'bosses', 'forge'];
export function loadFavs(): string[] {
  try { const v = JSON.parse(localStorage.getItem(FAV_KEY) ?? 'null'); if (Array.isArray(v)) return v.filter((k) => ALL_ITEMS.some((i) => i.key === k)); } catch { /* sem storage */ }
  return FAV_DEFAULT;
}
export function saveFavs(f: string[]) { try { localStorage.setItem(FAV_KEY, JSON.stringify(f)); } catch { /* sem storage */ } }
